import Button from '@ui/Button';
import Input from '@ui/Input';
import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Typography from '@ui/Typography';
import Switch from '@ui/Switch';
import { defaults, pick } from 'lodash-es';

const schema = yup.object().shape({
  firstName: yup.string().required('First Name is required'),
  lastName: yup.string().required('Last Name is required'),
  profileHeadline: yup.string().required('Profile Headline is required'),
  isOver18: yup.boolean().isTrue('You must be over 18 years old'),
});

function NonProfitOnBoardFormProfileStep(props) {
  const { onSubmit, onBack, formData } = props;

  const defaultValues = defaults(
    pick(formData, ['firstName', 'lastName', 'profileHeadline', 'isOver18']),
    {
      firstName: '',
      lastName: '',
      profileHeadline: '',
      isOver18: false,
    }
  );

  const form = useForm({
    defaultValues: defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
  } = form;

  const handleFormSubmit = async (data) => {
    onSubmit(data);
  };

  return (
    <div className="flex flex-col gap-12 flex-1 w-full">
      <Typography variant="dialogtitle">Set Up Your Account</Typography>

      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="flex flex-col gap-6">
        <Controller
          name="firstName"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Input
              label="First Name"
              required
              {...rest}
              error={errors.firstName?.message}
            />
          )}
        />

        <Controller
          name="lastName"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Input
              label="Last Name"
              required
              {...rest}
              error={errors.lastName?.message}
            />
          )}
        />

        <Controller
          name="profileHeadline"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Input
              label="Profile Headline"
              required
              {...rest}
              error={errors.profileHeadline?.message}
            />
          )}
        />

        <Controller
          name="isOver18"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Switch
              label="I am over 18 years old"
              {...rest}
              error={errors.isOver18?.message}
            />
          )}
        />

        <div className="flex justify-between flex-rows gap-4">
          <div className="flex-flow-col">
            <Button
              variant="outlined"
              color="primary"
              className="mt-2"
              onClick={onBack}>
              Back
            </Button>
          </div>

          <div className="flex-flow-col">
            <Button
              variant="filled"
              color="primary"
              type="submit"
              className="mt-2">
              Next
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default NonProfitOnBoardFormProfileStep;
